import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { Section, Container, SectionTitle, StatCard } from '../../ui';
import styles from './RepriseProof.module.css';

interface Stat {
  value: string;
  label: string;
}

export function RepriseProof() {
  const { t } = useTranslation('reprise');
  const statsRaw = t('proof.stats', { returnObjects: true });
  const stats: Stat[] = Array.isArray(statsRaw) ? (statsRaw as Stat[]) : [];
  const complianceRaw = t('proof.compliance', { returnObjects: true });
  const compliance: string[] = Array.isArray(complianceRaw) ? (complianceRaw as string[]) : [];

  return (
    <Section variant="light">
      <Container>
        <SectionTitle title={t('proof.title')} subtitle={t('proof.subtitle')} centered />
        <div className={styles.statsGrid}>
          {stats.map((stat) => (
            <StatCard key={stat.label} value={stat.value} label={stat.label} />
          ))}
        </div>

        <div className={styles.complianceBlock}>
          <h3 className={styles.complianceTitle}>{t('proof.complianceTitle')}</h3>
          <ul className={styles.complianceList}>
            {compliance.map((item) => (
              <li key={item} className={styles.complianceItem}>
                <CheckCircle2 size={20} className={styles.checkIcon} aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </Container>
    </Section>
  );
}
